export function variablesYaml() {
  return `variables:
  # todo: this should be in the configurations generated after login instead
  "**EmptyGUID**": "00000000-0000-0000-0000-000000000000"
  "**TemplateId**":
  "**TemplateName**": New Integration Profile
  "**TemplateDatabaseName**": 
  "**TemplateDescription**": New Integration Profile
  "**AuthorId**":
  "**AuthorFirstName**": HexaSync
  "**AuthorLastName**": Inc.
  "**AuthorEmail**": support@hexasync.com
  "**SelfConnectorId**":
  "**SelfConnectorProviderId**": c77e1450-9cc2-4dd8-9e80-ce12de4abceb
`;
}
